import * as R from "ramda";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";

export const getCodeDescription = R.curry((source, catalogo, defaultMessage, code) => {
  return (((source || {})[catalogo] || {})[code] || {}).text || defaultMessage;
});

const getCodeDescriptionSimple = R.curry((source, code) => {
  return ((source || {})[code] || {}).text;
});

export const getBusinessCode = function (response) {
  let businessCode = "ERROR";
  if (response && response.status == 200) {
    businessCode = response.data.meta.code;
  }
  return businessCode;
};

export const getResponseDTO = function (response) {
  let responseDTO = null;
  if (response && response.status == 200) {
    if ((response.data || {}).results) {
      responseDTO = response.data.results != undefined ? response.data.results : null;
    }
  }
  return responseDTO;
};

export const handleResponse = function (response, sourse) {
  const code = getBusinessCode(response);
  if (code == "OK") {
    EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "success");
    return true;
  } else {
    if (response) EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", code, getCodeDescriptionSimple(sourse, code));
    return false;
  }
};

export const handleResponseError = function (response, sourse) {
  const code = getBusinessCode(response);
  if (code == "OK") {
    return true;
  } else {
    if (response) EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", code, getCodeDescriptionSimple(sourse, code));
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/helpers/http-response-handler.js